import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { fDMA } from "../../../utils/fecha";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

// Contenedor y factura del proveedor en una sola celda (PDF y correo)
const contenedorYFactura = (a) =>
  [a.contenedor || "", a.factura ? `Fact. ${a.factura}` : ""].filter(Boolean).join(" · ");

function EstadoCuentaCXP() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ESTADO_CUENTA = process.env.REACT_APP_URL_ESTADO_CUENTA;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [proveedores, setProveedores] = useState([]);
 
  const [mailTo, setMailTo] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
 
  const [nombreProveedor, setNombreProveedor] = useState([]);
  const [saldo, setSaldo] = useState(0);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [modalMail2, setModalMail2] = useState(false);
  const toggleMail2 = () => setModalMail2(!modalMail2);
  const [modalMail3, setModalMail3] = useState(false);
  const toggleMail3 = () => setModalMail3(!modalMail3);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [modalAgrupado, setModalAgrupado] = useState(false);
  const toggleAgrupado = () => setModalAgrupado(!modalAgrupado);

  const [activo, setActivo] = useState("");
  const [vendedor, setVendedor] = useState("");
  const [grupo, setGrupo] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [movimientos, setMovimientos] = useState([]);

  const [idProveedor, setIdProveedor] = useState("");

  // D5: abonar y aplicar anticipos desde el propio estado de cuenta
  const URL_ABONOS_PROVEEDORES = process.env.REACT_APP_URL_ABONOS_PROVEEDORES;
  const URL_BANCOS = process.env.REACT_APP_URL_BANCOS;
  const URL_ANTICIPOS = process.env.REACT_APP_URL_ANTICIPOS;
  const URL_MOVIMIENTOS_BANCOS = process.env.REACT_APP_URL_MOVIMIENTOS_BANCOS;

  const [bancos, setBancos] = useState([]);
  const [anticiposProv, setAnticiposProv] = useState([]);

  // Modal: pagar una NotaCxP
  const [modalAbono, setModalAbono] = useState(false);
  const [notaSel, setNotaSel] = useState(null);
  const [abonoFecha, setAbonoFecha] = useState(moment().format("YYYY-MM-DD"));
  const [abonoImporte, setAbonoImporte] = useState(0);
  const [abonoBanco, setAbonoBanco] = useState("");
  const [abonoTC, setAbonoTC] = useState(1);
  const [abonoObs, setAbonoObs] = useState("NA");

  // Modal: aplicar un anticipo a una NotaCxP
  const [modalAplicar, setModalAplicar] = useState(false);
  const [anticipoSel, setAnticipoSel] = useState("");
  const [aplicarImporte, setAplicarImporte] = useState(0);

  const [guardandoCXP, setGuardandoCXP] = useState(false);

  // Modal: estado de cuenta agrupado por NotaCxP, con los pagos de cada nota
  // en su mismo bloque (igual que el "por surtido" de clientes).
  //
  // El corrido se redondea en cada paso: restar sin redondear deja residuos de
  // punto flotante y una nota saldada termina mostrando "-$0.00".
  const r2Nota = (n) => Math.round((Number(n) || 0) * 100) / 100;
  const fmtUSDNota = (n) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(r2Nota(n));
  const [modalPorNota, setModalPorNota] = useState(false);
  const togglePorNota = () => setModalPorNota(!modalPorNota);
  const [gruposPorNota, setGruposPorNota] = useState([]);
  const [anticiposPorNota, setAnticiposPorNota] = useState([]);

  // Catálogo de bancos (para el pago)
  useEffect(() => {
    if (!URL_BANCOS) return;
    axios
      .get(URL_BANCOS, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) => setBancos(res.data || []))
      .catch((err) => console.log(err));
  }, [URL_BANCOS]);

  // Anticipos con saldo del proveedor que se está viendo
  async function cargarAnticiposProveedor(idProv) {
    try {
      const res = await axios.get(URL_ANTICIPOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const conSaldo = (res.data || []).filter(
        (a) =>
          a.tipo === "Proveedor" &&
          a.is_active === "Si" &&
          Number(a.saldo) > 0.01 &&
          String(a.proveedores?.[0]?._id || a.proveedores?.[0]) === String(idProv)
      );
      setAnticiposProv(conSaldo);
    } catch (err) {
      console.log("[anticipos proveedor]", err);
      setAnticiposProv([]);
    }
  }

  function abrirAbonoNota(mov) {
    setNotaSel(mov);
    setAbonoFecha(moment().format("YYYY-MM-DD"));
    setAbonoImporte(Number(mov.saldo) || 0); // default: liquidar la nota
    setAbonoBanco("");
    setAbonoTC(1);
    setAbonoObs("NA");
    setModalAbono(true);
  }

  async function abrirAplicarAnticipo(mov) {
    setNotaSel(mov);
    setAnticipoSel("");
    setAplicarImporte(0);
    await cargarAnticiposProveedor(idProveedor);
    setModalAplicar(true);
  }

  // Guarda un pago normal (con banco) contra la NotaCxP
  async function guardarAbonoNota() {
    const imp = parseFloat(abonoImporte) || 0;
    if (imp <= 0) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Captura un importe mayor a 0" });
      return;
    }
    if (imp > Number(notaSel?.saldo || 0) + 0.01) {
      Swal.fire({ icon: "error", title: "Oops...", text: "El importe excede el saldo de la nota" });
      return;
    }
    if (!abonoBanco) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Selecciona el banco" });
      return;
    }
    try {
      setGuardandoCXP(true);
      await axios.post(
        URL_ABONOS_PROVEEDORES,
        {
          fecha: abonoFecha,
          importe: imp,
          proveedores: idProveedor,
          concepto: `Pago Nota ${notaSel?.numero}`,
          tipoCambio: Number(abonoTC) || 1,
          bancos: abonoBanco,
          notasCxP: notaSel?._id,
          observaciones: abonoObs || "NA",
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setModalAbono(false);
      Swal.fire({ icon: "success", title: "Pago registrado", timer: 1400, showConfirmButton: false });
      setTimeout(() => window.location.reload(), 1100);
    } catch (err) {
      console.log("[abono nota]", err);
      Swal.fire({
        icon: "error",
        title: "No se pudo registrar",
        text: err?.response?.data?.message || "Revisa los datos",
      });
    } finally {
      setGuardandoCXP(false);
    }
  }

  // Aplica un anticipo existente contra la NotaCxP (sin banco)
  async function guardarAplicarAnticipo() {
    const imp = parseFloat(aplicarImporte) || 0;
    const ant = anticiposProv.find((a) => a._id === anticipoSel);
    if (!ant) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Selecciona el anticipo" });
      return;
    }
    if (imp <= 0) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Captura un importe mayor a 0" });
      return;
    }
    if (imp > Number(ant.saldo) + 0.01) {
      Swal.fire({ icon: "error", title: "Oops...", text: "El importe excede el saldo del anticipo" });
      return;
    }
    if (imp > Number(notaSel?.saldo || 0) + 0.01) {
      Swal.fire({ icon: "error", title: "Oops...", text: "El importe excede el saldo de la nota" });
      return;
    }
    try {
      setGuardandoCXP(true);
      await axios.post(
        URL_ABONOS_PROVEEDORES,
        {
          fecha: moment().format("YYYY-MM-DD"),
          importe: imp,
          proveedores: idProveedor,
          concepto: `Anticipo #${ant.idAnticipo} Aplicado`,
          tipoCambio: Number(ant.tipoCambio) || 1,
          // Sin banco: el dinero ya salió cuando se creó el anticipo
          bancos: undefined,
          notasCxP: notaSel?._id,
          anticipos: ant._id,
          observaciones: `Aplicado desde Estado de Cuenta a Nota ${notaSel?.numero}`,
        },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      );
      setModalAplicar(false);
      Swal.fire({ icon: "success", title: "Anticipo aplicado", timer: 1400, showConfirmButton: false });
      setTimeout(() => window.location.reload(), 1100);
    } catch (err) {
      console.log("[aplicar anticipo]", err);
      Swal.fire({
        icon: "error",
        title: "No se pudo aplicar",
        text: err?.response?.data?.message || "Revisa los datos",
      });
    } finally {
      setGuardandoCXP(false);
    }
  }
  const [saldoInicial, setSaldoInicial] = useState(0);
  const [plazo, setPlazo] = useState(0);

    const [totalCargosMXN, setTotalCargosMXN] = useState(0);
    const [totalAbonosMXN, setTotalAbonosMXN] = useState(0);
    const [totalSaldoMXN, setTotalSaldoMXN] = useState(0);
    const [totalCargosUSD, setTotalCargosUSD] = useState(0);
    const [totalAbonosUSD, setTotalAbonosUSD] = useState(0);
    const [totalSaldoUSD, setTotalSaldoUSD] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
    .get(`${URL_PROVEEDORES}Tipo/China`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allProveedores = response.data;
        // Array para pagination
        let arrayTabla = allProveedores
          .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
          .map((a) => {
              return {
                _id: a._id,
                activo: a.is_active,
                nombre_comercial: a.nombre_comercial,
                moneda: a.moneda,
                // Sin `|| 0`, un proveedor sin estos campos sale con $NaN en
                // toda su fila (HONGDA TYRE, por ejemplo).
                cargos: parseFloat(a.cargos) || 0,
                abonos: parseFloat(a.abonos) || 0,
                saldo: parseFloat(a.saldo) || 0,
              };
          
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setProveedores(allProveedores);
        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });
  

    let SI = movimientos
      .map((c) => {
        if (selectedFechaInicio) {
          if (
            (selectedFechaInicio == "" || selectedFechaInicio > c.fecha)
          ) {
            return c.cargo - c.abono;
          }
        } else {
          return 0;
        }
      })
      .filter(function (el) {
        return el != null;
      });

    let TC = SI.reduce((t, total, index) => t + total, 0);

    setSaldoInicial(TC);
  }, [user, movimientos, selectedFechaInicio]);

  const ListaProveedores = comments.sort((a, b) =>
    a.nombre_comercial > b.nombre_comercial ? 1 : -1
  );

  function PDFTabla() {
    let totalCargos = 0;
    let totalAbonos = 0;
    let totalSaldo = 0;
    const data = ListaProveedores.map((a) => {
      if (
        (activo == 0 || activo == a.is_active)
      ) {
        return [a.nombre_comercial,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Estado de Cuenta Proveedores`, 15, 40);
    doc.autoTable({
      head: [
        [
          "Proveedor",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldo),
        ],
      ],
      showFoot: "lastPage",
    });
    abrePDF(doc, `EstadosDeCuentaProv.pdf`);
  }

  function excel() {
    const dataExcel = ListaProveedores.map((a) => {
      if (
        (activo == 0 || activo == a.is_active)
      ) {
        return {
          Proveedor: a.nombre_comercial,
          Moneda: a.moneda,
          Cargos: a.cargos,
          Abonos: a.abonos,
          Saldo: a.saldo,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "EstadoCuentaProv";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuentaProv",
        sheetFilter: [
          "Proveedor",
          "Moneda",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
        sheetHeader: [
          "Proveedor",
          "Moneda",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let totalCargos = 0;
    let totalAbonos = 0;
    let totalSaldo = 0;
    const data = ListaProveedores.map((a) => {
      if (
        (activo == 0 || activo == a.is_active)
      ) {
        return [a.nombre_comercial,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Estado de Cuenta Proveedores`, 15, 40);
    doc.autoTable({
      head: [
        [
          "Proveedor",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldo),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Estado de Cuenta",
          email: mailTo,
          fileName: "EstadoCuenta.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras los saldos de los proveedores.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Moneda", field: "moneda", sortable: true },
    { name: "Cargos", field: "cargos", sortable: true },
    { name: "Abonos", field: "abonos", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Estado Cuenta", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre_comercial.toLowerCase().includes(search.toLowerCase()) ||
          comment.moneda.toLowerCase().includes(search.toLowerCase()) ||
          comment.cargos.toString().includes(search) ||
          comment.abonos.toString().includes(search) ||
          comment.saldo.toString().includes(search)
      );
    }

    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }

    let pesos = computedComments.filter((e) => e.moneda == "MXN");

    let carP = pesos.map((c) => parseFloat(c.cargos));
    let TcarP = carP.reduce((t, cajas, index) => t + cajas, 0);
    setTotalCargosMXN(TcarP);

    let aboP = pesos.map((c) => parseFloat(c.abonos));
    let TaboP = aboP.reduce((t, cajas, index) => t + cajas, 0);
    setTotalAbonosMXN(TaboP);

    let aslP = pesos.map((c) => parseFloat(c.saldo));
    let TaslP = aslP.reduce((t, cajas, index) => t + cajas, 0);
    setTotalSaldoMXN(TaslP);

    let dls = computedComments.filter((e) => e.moneda == "USD");

    let carD = dls.map((c) => parseFloat(c.cargos));
    let TcarD = carD.reduce((t, cajas, index) => t + cajas, 0);
    setTotalCargosUSD(TcarD);

    let aboD = dls.map((c) => parseFloat(c.abonos));
    let TaboD = aboD.reduce((t, cajas, index) => t + cajas, 0);
    setTotalAbonosUSD(TaboD);

    let aslD = dls.map((c) => parseFloat(c.saldo));
    let TaslD = aslD.reduce((t, cajas, index) => t + cajas, 0);
    setTotalSaldoUSD(TaslD);
  
    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cargos" &&
      sorting.field != "abonos" &&
      sorting.field != "saldo"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "cargos" ||
        sorting.field == "abonos" ||
        sorting.field == "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "cargos" ||
        sorting.field == "abonos" ||
        sorting.field == "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    activo,
  ]);

  // ---- Crear anticipo al proveedor, sin salir del estado de cuenta ----
  // Replica el alta de AnticiposProveedoresCreate: además del anticipo hay
  // que registrar el EGRESO en el banco, si no la cuenta bancaria queda
  // cuadrando de más.
  const [modalAnticipoNuevo, setModalAnticipoNuevo] = useState(false);
  const [provAnticipo, setProvAnticipo] = useState(null);
  const [antFecha, setAntFecha] = useState(moment().format("YYYY-MM-DD"));
  const [antImporte, setAntImporte] = useState("");
  const [antBanco, setAntBanco] = useState("");
  const [antFormaPago, setAntFormaPago] = useState("Transferencia");
  const [antTipoCambio, setAntTipoCambio] = useState(1);
  const [antObservaciones, setAntObservaciones] = useState("NA");
  const [antGuardando, setAntGuardando] = useState(false);

  function abrirAnticipoNuevo(p) {
    setProvAnticipo(p);
    setAntFecha(moment().format("YYYY-MM-DD"));
    setAntImporte("");
    setAntBanco("");
    setAntFormaPago("Transferencia");
    setAntTipoCambio(1);
    setAntObservaciones("NA");
    setModalAnticipoNuevo(true);
  }

  async function guardarAnticipoNuevo() {
    const imp = Number(antImporte) || 0;
    if (!antBanco || imp <= 0) {
      return Swal.fire({
        icon: "error",
        title: "Faltan datos",
        text: "Captura el banco y un importe mayor a 0",
      });
    }
    setAntGuardando(true);
    const auth = {
      headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
    };
    try {
      const { data } = await axios.post(
        URL_ANTICIPOS,
        {
          fecha: antFecha,
          importe: imp,
          formaPago: antFormaPago,
          bancos: antBanco,
          proveedores: provAnticipo._id,
          utilizado: 0,
          saldo: imp,
          tipoCambio: Number(antTipoCambio) || 1,
          tipo: "Proveedor",
          observaciones: antObservaciones || "NA",
        },
        auth
      );

      const bancoObj = (bancos || []).find((b) => b._id === antBanco);
      await axios.post(
        URL_MOVIMIENTOS_BANCOS,
        {
          fecha: antFecha,
          importe: -imp,
          tipo: "Egreso",
          bancos: antBanco,
          anticipos: data._id,
          moneda: bancoObj?.moneda || "MXN",
          tipoCambio: 1,
        },
        auth
      );

      try {
        await axios.post(
          URL_LOGS,
          {
            tipo: "Crear Anticipo Proveedor",
            detalle: `Fecha: ${antFecha} / Proveedor: ${provAnticipo.nombre_comercial} / Importe: ${imp}`,
            user: user.id,
          },
          auth
        );
      } catch (e) { console.log("log anticipo:", e); }

      setModalAnticipoNuevo(false);
      Swal.fire("Good job!", "Anticipo creado", "success");
      setTimeout(() => window.location.reload(), 1200);
    } catch (error) {
      console.log("crear anticipo:", error);
      Swal.fire({
        icon: "error",
        title: "No se pudo crear el anticipo",
        text: error?.response?.data?.message || "",
      });
    } finally {
      setAntGuardando(false);
    }
  }

  async function jalaMov(id, proveedor, saldo) {
    await axios
      .get(`${URL_ESTADO_CUENTA}CXP/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        setMovimientos(allVentas);
        //
      })
      .catch((err) => {
        console.log(err);
      });
    setNombreProveedor(proveedor);
    setIdProveedor(id);
    setSaldo(saldo);
    toggle();
  }

  async function jalaMovPorNota(id, proveedor, saldo) {
    await axios
      .get(`${URL_ESTADO_CUENTA}CXPPorNota/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const data = response.data || {};
        setGruposPorNota(Array.isArray(data.grupos) ? data.grupos : []);
        setAnticiposPorNota(Array.isArray(data.anticipos) ? data.anticipos : []);
      })
      .catch((err) => {
        console.log(err);
        setGruposPorNota([]);
        setAnticiposPorNota([]);
      });
    setNombreProveedor(proveedor);
    setIdProveedor(id);
    setSaldo(saldo);
    await cargarAnticiposProveedor(id);
    togglePorNota();
  }

  function PDFPorNota() {
    const doc = new jsPDF("landscape", "mm", "a4", true);
    const img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 240, 12, 35, 15);
    doc.text(`Estado de Cuenta por Nota`, 15, 20);
    doc.text(`Proveedor ${nombreProveedor}`, 15, 27);
    if (selectedFechaInicio) doc.text(`Desde ${fDMA(selectedFechaInicio)}`, 15, 34);

    // Un renglón por nota y, debajo, uno por cada pago que se le aplicó. El
    // corrido se reinicia en cada nota: es un saldo por documento, no global.
    const body = [];
    let totCargos = 0;
    let totAbonos = 0;
    let totSaldo = 0;

    gruposPorNota
      .filter((g) => !selectedFechaInicio || selectedFechaInicio <= g?.nota?.fecha)
      .forEach((g) => {
        const n = g.nota;
        let corrido = Number(n.total_costo || 0);
        totCargos += Number(n.total_costo || 0);
        totSaldo += Number(n.saldo || 0);
        body.push([
          { content: `Nota ${n.idNotasCxP}`, styles: { fontStyle: "bold" } },
          fDMA(n.fecha),
          n.embarque ? `Embarque ${n.embarque}` : "Nota",
          n.factura ? `Factura ${n.factura}` : "",
          n.contenedor || "",
          fmtUSDNota(n.total_costo),
          "",
          fmtUSDNota(corrido),
        ]);
        (g.movimientos || []).forEach((m) => {
          corrido = r2Nota(corrido - Number(m.abono || 0));
          totAbonos += Number(m.abono || 0);
          body.push([
            `#${m.numero ?? ""}`,
            fDMA(m.fecha),
            m.movimiento,
            m.observaciones || "",
            m.banco || "NA",
            "",
            fmtUSDNota(m.abono),
            fmtUSDNota(corrido),
          ]);
        });
        body.push([
          "",
          "",
          "",
          "",
          "",
          "",
          { content: "Saldo Nota", styles: { fontStyle: "bold", halign: "right" } },
          { content: fmtUSDNota(n.saldo), styles: { fontStyle: "bold" } },
        ]);
      });

    const dispAnticipos = anticiposPorNota.reduce(
      (t, a) => t + Number(a.saldo || 0),
      0
    );

    doc.autoTable({
      head: [
        ["Folio", "Fecha", "Movimiento", "Observaciones", "Banco", "Cargos", "Abonos", "Saldo"],
      ],
      body,
      headStyles: { fillColor: ["#B02307"], lineWidth: 0 },
      footStyles: { fillColor: ["#B02307"] },
      theme: "grid",
      startY: 40,
      styles: { fontSize: 8 },
      columnStyles: {
        5: { halign: "right" },
        6: { halign: "right" },
        7: { halign: "right" },
      },
      foot: [
        ["", "", "", "", "", { content: "Total Cargos", colSpan: 2, styles: { halign: "right" } }, fmtUSDNota(totCargos)],
        ["", "", "", "", "", { content: "Total Abonos", colSpan: 2, styles: { halign: "right" } }, fmtUSDNota(totAbonos)],
        ["", "", "", "", "", { content: "Saldo de Notas", colSpan: 2, styles: { halign: "right" } }, fmtUSDNota(totSaldo)],
        ["", "", "", "", "", { content: "Anticipos por aplicar", colSpan: 2, styles: { halign: "right" } }, fmtUSDNota(dispAnticipos)],
        ["", "", "", "", "", { content: "Saldo Neto", colSpan: 2, styles: { halign: "right" } }, fmtUSDNota(totSaldo - dispAnticipos)],
      ],
      showFoot: "lastPage",
    });

    // Detalle de los anticipos que todavía no se aplican a ninguna nota. Va en
    // su propia tabla porque no cuelgan de ningún documento del corrido.
    if (anticiposPorNota.length > 0) {
      const finY = doc.lastAutoTable ? doc.lastAutoTable.finalY : 40;
      doc.text(`Anticipos por aplicar`, 15, finY + 12);
      doc.autoTable({
        head: [
          ["Folio", "Fecha", "Banco", "Observaciones", "Importe", "Utilizado", "Disponible"],
        ],
        body: anticiposPorNota.map((a) => [
          a.idAnticipo,
          fDMA(a.fecha),
          a.banco || "NA",
          a.observaciones || "",
          fmtUSDNota(a.importe),
          fmtUSDNota(a.utilizado),
          fmtUSDNota(a.saldo),
        ]),
        headStyles: { fillColor: ["#B02307"], lineWidth: 0 },
        footStyles: { fillColor: ["#B02307"] },
        theme: "grid",
        startY: finY + 16,
        styles: { fontSize: 8 },
        columnStyles: {
          4: { halign: "right" },
          5: { halign: "right" },
          6: { halign: "right" },
        },
        foot: [
          [
            "",
            "",
            "",
            "",
            "",
            { content: "Total por aplicar", styles: { halign: "right" } },
            fmtUSDNota(dispAnticipos),
          ],
        ],
        showFoot: "lastPage",
      });
    }

    abrePDF(doc, `EdoCtaPorNota-${nombreProveedor}.pdf`);
  }

  function PDFOC() {
    let saldoParcial = saldoInicial;
    let totalCargosEdoCte = 0;
    let totalAbonosEdoCte = 0;
    let totalSaldoEdoCte = 0;

    const data = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        totalCargosEdoCte = totalCargosEdoCte + a.cargo;
        totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
        totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo;
        saldoParcial = saldoParcial + a.cargo - a.abono;
        const cargos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargo);
        const abonos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abono);
        var saldoParcialFormato =
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial);
        return [
          a.fecha,
          a.movimiento,
          contenedorYFactura(a),
          a.numero,
          a.banco,
          cargos,
          abonos,
          saldoParcialFormato,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 25, 35, 15);
    // doc.setFontSize(14)
    doc.text(`Estado de Cuenta`, 15, 30);
    doc.text(`Proveedor ${nombreProveedor}`, 15, 37);
    doc.text(`Desde ${selectedFechaInicio}`, 15, 44);
    doc.autoTable({
      head: [
        [
          "Date",
          "Type",
          "Container",
          "Number",
          "Bank",
          "Charges",
          "Payments",
          "Balance",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "",
          { content: "Saldo Anterior", colSpan: 2, styles: { halign: "left" } },
          // "Saldo Anterior",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial),
        ],
        [
          "",
          "",
          "",
          "",
          {
            content: "Cargos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosEdoCte),
        ],
        [
          "",
          "",
          "",
          "",
          {
            content: "Abonos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosEdoCte),
        ],
        [
          "",
          "",
          "",
          "",
          { content: "Saldo Actual", colSpan: 2, styles: { halign: "left" } },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
        ],
      ],
      showFoot: "lastPage",
    });
    abrePDF(doc, `EdoCtaProveedor-${nombreProveedor}.pdf`);
  }

  function emailFOC() {
    let saldoParcial = saldoInicial;
    let totalCargosEdoCte = 0;
    let totalAbonosEdoCte = 0;
    let totalSaldoEdoCte = 0;

    const data = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        totalCargosEdoCte = totalCargosEdoCte + a.cargo;
        totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
        totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo;
        saldoParcial = saldoParcial + a.cargo - a.abono;
        const cargos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargo);
        const abonos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abono);
        var saldoParcialFormato =
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial);
        return [
          a.fecha,
          a.movimiento,
          contenedorYFactura(a),
          a.numero,
          a.banco,
          cargos,
          abonos,
          saldoParcialFormato,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 25, 35, 15);
    // doc.setFontSize(14)
    doc.text(`Estado de Cuenta`, 15, 30);
    doc.text(`Proveedor ${nombreProveedor}`, 15, 37);
    doc.text(`Desde ${selectedFechaInicio}`, 15, 44);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Movimiento",
          "Contenedor",
          "Numero",
          "Banco",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "",
          { content: "Saldo Anterior", colSpan: 2, styles: { halign: "left" } },
          // "Saldo Anterior",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial),
        ],
        [
          "",
          "",
          "",
          "",
          {
            content: "Cargos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosEdoCte),
        ],
        [
          "",
          "",
          "",
          "",
          {
            content: "Abonos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosEdoCte),
        ],
        [
          "",
          "",
          "",
          "",
          { content: "Saldo Actual", colSpan: 2, styles: { halign: "left" } },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
        ],
      ],
      showFoot: "lastPage",
    });
    abrePDF(doc, `EdoCtaProveedor-${nombreProveedor}.pdf`);
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Estado de Cuenta",
          email: mailTo,
          fileName: `EstadoCuenta-${nombreProveedor}.pdf`,
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Estado de Cuenta de ${nombreProveedor}.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail2();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }

  function excelFOC() {
    const dataExcel = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        return {
          Fecha: a.fecha,
          Movimiento: a.movimiento,
          Contenedor: a.contenedor || "",
          Factura: a.factura || "",
          Numero: a.numero,
          Cargo: a.cargo,
          Abono: a.abono,
          Cargos: a.cargos,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `EdoCtaProveedor-${nombreProveedor}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuentaProv",
        sheetFilter: [
          "Fecha",
          "Movimiento",
          "Contenedor",
          "Factura",
          "Numero",
          "Cargo",
          "Abono",
        ],
        sheetHeader: [
          "Fecha",
          "Movimiento",
          "Contenedor",
          "Factura",
          "Numero",
          "Cargo",
          "Abono",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  
  let totalCargosTabla = 0;
  let totalAbonosTabla = 0;
  let totalSaldoTabla = 0;

  let saldoParcialTabla = saldoInicial;
  let totalCargosEdo = 0;
  let totalAbonosEdo = 0;
  let totalSaldoEdo = 0;

  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const secondDate = new Date(hoy);
  let saldoVencido =0

  return (
    <>
      <Header />
      <br />
      <br />
      {user.edoCtaProveedores ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuCXP"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          <h3 align="center">Cuentas Por Pagar</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
           
            <Col md={2}>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((p) => {
                totalCargosTabla = totalCargosTabla + parseFloat(p.cargos);
                totalAbonosTabla = totalAbonosTabla + parseFloat(p.abonos);
                totalSaldoTabla = totalSaldoTabla + parseFloat(p.saldo);
                {
                  return (
                    <tr
                          style={
                            p.saldo > 0
                              ? { backgroundColor: "#ed8c8c" }
                              : p.saldo < 0
                              ? { backgroundColor: "#64e379" }
                              : null
                          }
                        >
                      <td> {p.nombre_comercial}</td>
                      <td>{p.moneda}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(p.cargos)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(p.abonos)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(p.saldo)}
                      </td>
                      <td>
                        <Button
                          color="info"
                          size="sm"
                          onClick={(e) =>
                            jalaMov(p._id, p.nombre_comercial, p.saldo)
                          }
                          id="Detalle"
                        >
                          <i class="fas fa-file-alt"></i>
                        </Button>
                        {" "}
                        {/* Estado de cuenta por Nota: los abonos de cada
                            NotaCxP salen en su mismo bloque. */}
                        <Button
                          color="danger"
                          size="sm"
                          title="Estado de Cuenta por Nota"
                          onClick={(e) =>
                            jalaMovPorNota(p._id, p.nombre_comercial, p.saldo)
                          }
                          id="DetallePorNota"
                        >
                          <i class="fas fa-receipt"></i>
                        </Button>
                        {" "}
                        {/* Crear anticipo para este proveedor. Lleva al alta
                            en vez de repetir el flujo aquí: ese formulario
                            también registra el movimiento bancario, y
                            duplicarlo abriría la puerta a que se desincronicen. */}
                        <Button
                          color="success"
                          size="sm"
                          title="Crear anticipo a este proveedor"
                          onClick={() => abrirAnticipoNuevo(p)}
                        >
                          <i className="fas fa-hand-holding-usd"></i>
                        </Button>

                        {/* <Button
                          color="success"
                          size="sm"
                          onClick={(e) =>
                            jalaMovAgrupado(p._id, p.proveedor, p.plazo, p.saldo)
                          }
                          id="Detalle"
                        >
                          <i class="far fa-newspaper"></i>
                        </Button> */}
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td className="negrita" align="right">
                  TOTAL PESOS
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosMXN)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosMXN)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldoMXN)}
                </td>
                <td></td>
              </tr>
              <tr>
                <td></td>
                <td className="negrita" align="right">
                  TOTAL DOLARES
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosUSD)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosUSD)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldoUSD)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      {/* Estado de Cuenta por Nota: cada NotaCxP con sus abonos debajo */}
      <Modal
        size="xxl"
        isOpen={modalPorNota}
        toggle={togglePorNota}
        style={{ maxWidth: "95%", margin: "0 auto" }}
        contentClassName="custom-modal-content"
      >
        <ModalHeader toggle={togglePorNota}>
          <h4>Estado de Cuenta por Nota - {nombreProveedor}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={3}>
              <ButtonGroup>
                <Button size="sm" className="btn" color="danger" onClick={PDFPorNota}>
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
              </ButtonGroup>
            </Col>
            <Col md={4}>
              <Row>
                <Col md={3}>
                  <Label className="mr-sm-2">Desde</Label>
                </Col>
                <Col md={6}>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    onChange={(e) => setSelectedFechaInicio(e.target.value)}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={5}>
              <h4 align="right">
                Saldo{"  "}
                <Badge id="TotalPorNota" color="danger" className="BadgeSize badge-pill">
                  {fmtUSDNota(saldo)}
                </Badge>
              </h4>
            </Col>
          </Row>
          <div className="card container">
            {gruposPorNota.length === 0 ? (
              <p style={{ padding: 12 }}>Sin notas.</p>
            ) : (
              gruposPorNota
                .filter(
                  (g) => !selectedFechaInicio || selectedFechaInicio <= g?.nota?.fecha
                )
                .map((g, idx) => {
                  const n = g.nota;
                  const movs = g.movimientos || [];
                  let corrido = Number(n.total_costo || 0);
                  return (
                    <div key={n._id || idx} style={{ marginBottom: 20 }}>
                      {Number(n.saldo) > 0.01 && (
                        <div style={{ marginBottom: 4 }}>
                          <Button
                            size="sm"
                            color="success"
                            title="Registrar un pago a esta nota"
                            onClick={() =>
                              abrirAbonoNota({ ...n, numero: n.idNotasCxP })
                            }
                          >
                            <i className="fas fa-dollar-sign"></i> Abonar
                          </Button>{" "}
                          <Button
                            size="sm"
                            color="info"
                            title="Aplicar un anticipo del proveedor a esta nota"
                            onClick={() =>
                              abrirAplicarAnticipo({ ...n, numero: n.idNotasCxP })
                            }
                          >
                            <i className="fas fa-hand-holding-usd"></i> Aplicar anticipo
                          </Button>
                        </div>
                      )}
                      <Table size="sm" striped borderless className="table-responsive-xl">
                        <thead>
                          <tr align="center">
                            <th className="tituloTabla">Folio</th>
                            <th className="tituloTabla">Fecha</th>
                            <th className="tituloTabla">Movimiento</th>
                            <th className="tituloTabla">Observaciones</th>
                            <th className="tituloTabla">Banco / Contenedor</th>
                            <th className="tituloTabla">Cargos</th>
                            <th className="tituloTabla">Abonos</th>
                            <th className="tituloTabla">Saldo</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td align="center">
                              <b>{n.idNotasCxP}</b>
                            </td>
                            <td align="center">{fDMA(n.fecha)}</td>
                            <td align="center">
                              <b>{n.embarque ? `Embarque ${n.embarque}` : "Nota"}</b>
                            </td>
                            <td align="center">{n.factura ? <b>Factura {n.factura}</b> : ""}</td>
                            <td align="center">{n.contenedor || ""}</td>
                            <td align="right">{fmtUSDNota(n.total_costo)}</td>
                            <td align="right"></td>
                            <td align="right">{fmtUSDNota(corrido)}</td>
                          </tr>
                          {movs.map((m, i) => {
                            corrido = r2Nota(corrido - Number(m.abono || 0));
                            return (
                              <tr key={m._id || i}>
                                <td align="center">{m.numero ?? ""}</td>
                                <td align="center">{fDMA(m.fecha)}</td>
                                <td align="center">{m.movimiento}</td>
                                <td align="center">{m.observaciones}</td>
                                <td align="center">{m.banco || "NA"}</td>
                                <td align="right"></td>
                                <td align="right">{fmtUSDNota(m.abono)}</td>
                                <td align="right">{fmtUSDNota(corrido)}</td>
                              </tr>
                            );
                          })}
                          <tr>
                            <td colSpan={6}></td>
                            <td className="negrita" align="right">
                              Saldo Nota
                            </td>
                            <td className="negrita" align="right">
                              {fmtUSDNota(n.saldo)}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  );
                })
            )}

            {/* Anticipos con saldo: dinero ya entregado que no cuelga de
                ninguna nota todavía. */}
            {anticiposPorNota && anticiposPorNota.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <h5 style={{ background: "#B02307", color: "#fff", padding: 6 }}>
                  Anticipos por aplicar
                </h5>
                <Table size="sm" striped borderless className="table-responsive-xl">
                  <thead>
                    <tr align="center">
                      <th className="tituloTabla">Folio</th>
                      <th className="tituloTabla">Fecha</th>
                      <th className="tituloTabla">Banco</th>
                      <th className="tituloTabla">Observaciones</th>
                      <th className="tituloTabla">Importe</th>
                      <th className="tituloTabla">Utilizado</th>
                      <th className="tituloTabla">Disponible</th>
                    </tr>
                  </thead>
                  <tbody>
                    {anticiposPorNota.map((a, i) => (
                      <tr key={a._id || i}>
                        <td align="center">{a.idAnticipo}</td>
                        <td align="center">{fDMA(a.fecha)}</td>
                        <td align="center">{a.banco || "NA"}</td>
                        <td align="center">{a.observaciones}</td>
                        <td align="right">{fmtUSDNota(a.importe)}</td>
                        <td align="right">{fmtUSDNota(a.utilizado)}</td>
                        <td align="right">{fmtUSDNota(a.saldo)}</td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={5}></td>
                      <td className="negrita" align="right">
                        Total por aplicar
                      </td>
                      <td className="negrita" align="right">
                        {fmtUSDNota(
                          anticiposPorNota.reduce((t, a) => t + Number(a.saldo || 0), 0)
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            {/* Totales generales del proveedor */}
            {gruposPorNota.length > 0 &&
              (() => {
                const totCargos = gruposPorNota.reduce(
                  (t, g) => t + Number(g?.nota?.total_costo || 0),
                  0
                );
                const totAbonos = gruposPorNota.reduce((t, g) => {
                  const movs = Array.isArray(g?.movimientos) ? g.movimientos : [];
                  return t + movs.reduce((s, m) => s + Number(m.abono || 0), 0);
                }, 0);
                const totSaldo = gruposPorNota.reduce(
                  (t, g) => t + Number(g?.nota?.saldo || 0),
                  0
                );
                const dispAnt = anticiposPorNota.reduce(
                  (t, a) => t + Number(a.saldo || 0),
                  0
                );
                return (
                  <div style={{ marginTop: 16 }}>
                    <h5 style={{ background: "#B02307", color: "#fff", padding: 6 }}>
                      Totales generales del proveedor
                    </h5>
                    <Table size="sm" borderless className="table-responsive-xl">
                      <tbody>
                        <tr>
                          <td className="negrita" align="right" style={{ width: "70%" }}>
                            Total Cargos
                          </td>
                          <td className="negrita" align="right">
                            {fmtUSDNota(totCargos)}
                          </td>
                        </tr>
                        <tr>
                          <td className="negrita" align="right">
                            Total Abonos
                          </td>
                          <td className="negrita" align="right" style={{ color: "#f40903" }}>
                            {fmtUSDNota(totAbonos)}
                          </td>
                        </tr>
                        <tr>
                          <td className="negrita" align="right">
                            Saldo de Notas
                          </td>
                          <td className="negrita" align="right">
                            {fmtUSDNota(totSaldo)}
                          </td>
                        </tr>
                        <tr>
                          <td className="negrita" align="right">
                            Anticipos por aplicar
                          </td>
                          <td className="negrita" align="right" style={{ color: "#f40903" }}>
                            {fmtUSDNota(dispAnt)}
                          </td>
                        </tr>
                        <tr>
                          <td className="negrita" align="right">
                            Saldo Neto
                          </td>
                          <td className="negrita" align="right">
                            {fmtUSDNota(totSaldo - dispAnt)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                );
              })()}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={togglePorNota}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xxl" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Estado de Cuenta de {nombreProveedor}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={2}>
              <ButtonGroup>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFOC}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="info"
                  onClick={toggleMail2}
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelFOC}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>

            <Col md={3}>
              <Row>
                <Col md={3}>
                  <Label className="mr-sm-2">Fecha</Label>
                </Col>
                <Col md={6}>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    required
                    onChange={(e) => {
                      setSelectedFechaInicio(e.target.value);
                    }}
                  />
                </Col>
              </Row>
            </Col>

          

            <Col md={3}>
              <h4 align="right">
                Saldo{"  "}
                <Badge
                  id="Total"
                  color="danger"
                  className="BadgeSize badge-pill"
                >
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldo)}
                </Badge>
              </h4>
            </Col>
          </Row>
          <div className="card container">
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr align="center">
                  <th className="tituloTabla" align="left">
                    Fecha
                  </th>
                  <th className="tituloTabla">Movimiento</th>
                  <th className="tituloTabla">Contenedor</th>
                  <th className="tituloTabla">Numero</th>
                  <th className="tituloTabla">Banco</th>
                  {/* <th className="tituloTabla">Tipo Cambio</th> */}
                  <th className="tituloTabla">Cargos</th>
                  <th className="tituloTabla">Abonos</th>
                  <th className="tituloTabla">Saldo</th>
                  <th className="tituloTabla">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {selectedFechaInicio ? (
                  <tr>
                    {/* <td align="center">NA</td> */}
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="right">Saldo Anterior</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">
                      {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial)}
                    </td>
                  </tr>
                ) : undefined}
                {movimientos.map((c) => {
                  if (
                    (selectedFechaInicio == "" ||
                      selectedFechaInicio <= c.fecha)
                  ) {
                    saldoParcialTabla = saldoParcialTabla + c.cargo - c.abono;
                    totalCargosEdo = totalCargosEdo + c.cargo;
                    totalAbonosEdo = totalAbonosEdo + c.abono;
                    totalSaldoEdo = totalCargosEdo - totalAbonosEdo;
                      return (
                        <tr>
                          <td align="center">{fDMA(c.fecha)}</td>
                          <td align="center">{c.movimiento}</td>
                          <td align="center">
                            {c.contenedor || ""}
                            {c.factura ? (
                              <div style={{ fontSize: 12, color: "#6c757d" }}>Fact. {c.factura}</div>
                            ) : null}
                          </td>
                          <td align="center">{c.numero}</td>
                          <td align="center">{c.banco}</td>
                          {/* <td align="center">{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.tipoCambio)}</td> */}
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.cargo)}
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.abono)}
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                                saldoParcialTabla
                              )}
                          </td>
                          {/* D5: abonar / aplicar anticipo sin salir del estado de cuenta */}
                          <td align="center">
                            {c.tipo === "NotaCxP" && Number(c.saldo) > 0.01 ? (
                              <>
                                <Button
                                  size="sm"
                                  color="success"
                                  title="Registrar un pago a esta nota"
                                  onClick={() => abrirAbonoNota(c)}
                                >
                                  <i className="fas fa-dollar-sign"></i>
                                </Button>{" "}
                                <Button
                                  size="sm"
                                  color="info"
                                  title="Aplicar un anticipo a esta nota"
                                  onClick={() => abrirAplicarAnticipo(c)}
                                >
                                  <i className="fas fa-hand-holding-usd"></i>
                                </Button>
                              </>
                            ) : c.tipo === "Anticipo" && Number(c.saldoAnticipo) > 0.01 ? (
                              <span style={{ color: "#0d6efd", fontWeight: 600 }}>
                                Disponible{" "}
                                {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.saldoAnticipo)}
                              </span>
                            ) : null}
                          </td>
                        </tr>
                      )
                  }
                })}

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  {/* <td></td> */}
                  <td></td>
                  <td td className="negrita">
                    Saldo Anterior
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial)}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  {/* <td></td> */}
                  <td></td>
                  <td td className="negrita">
                    Cargos del Periodo
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosEdo)}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  {/* <td></td> */}
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Abonos del Periodo
                  </td>
                  <td td className="negrita" align="right">
                    {"-" + new Intl.NumberFormat("en-US",{style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosEdo)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  {/* <td></td> */}
                  <td></td>
                  <td td className="negrita">
                    Saldo Actual
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcialTabla)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>



       <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}>
          <h4>Enviar Estado de Cuenta</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={enviaMail}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal size="sm" isOpen={modalMail2} toggle={toggleMail2}>
        <ModalHeader toggle={toggleMail2}>
          <h4>Enviar Estado de Cuenta</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={emailFOC}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>

      {/* D5: pagar una NotaCxP desde el estado de cuenta */}
      <Modal size="lg" isOpen={modalAbono} toggle={() => setModalAbono(!modalAbono)}>
        <ModalHeader toggle={() => setModalAbono(!modalAbono)}>
          <h4>
            Pagar {notaSel?.movimiento} — {nombreProveedor}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Saldo de la nota</Label>
              <Input
                disabled
                value={new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(notaSel?.saldo) || 0)}
              />
            </Col>
            <Col md={4}>
              <Label>Fecha</Label>
              <Input type="date" value={abonoFecha} onChange={(e) => setAbonoFecha(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Tipo de Cambio</Label>
              <Input type="number" min="0" step="any" value={abonoTC} onChange={(e) => setAbonoTC(e.target.value)} />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <Label>Importe</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={abonoImporte}
                onChange={(e) => setAbonoImporte(e.target.value)}
              />
            </Col>
            <Col md={4}>
              <Label>Banco</Label>
              <Input type="select" value={abonoBanco} onChange={(e) => setAbonoBanco(e.target.value)}>
                <option value="">Selecciona</option>
                {bancos
                  .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                  .map((b) => (
                    <option key={b._id} value={b._id}>
                      {b.banco} {b.cuenta}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={4}>
              <Label>Observaciones</Label>
              <Input type="text" value={abonoObs} onChange={(e) => setAbonoObs(e.target.value)} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarAbonoNota} disabled={guardandoCXP}>
            {guardandoCXP ? "Guardando..." : "Registrar pago"}
          </Button>
          <Button color="secondary" onClick={() => setModalAbono(false)} disabled={guardandoCXP}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* D5: aplicar un anticipo existente a la NotaCxP */}
      {/* Alta de anticipo al proveedor, sin salir del estado de cuenta */}
      <Modal
        size="md"
        isOpen={modalAnticipoNuevo}
        toggle={() => setModalAnticipoNuevo(!modalAnticipoNuevo)}
      >
        <ModalHeader toggle={() => setModalAnticipoNuevo(!modalAnticipoNuevo)}>
          <h4>Nuevo anticipo — {provAnticipo?.nombre_comercial}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>Fecha</Label>
              <Input
                bsSize="sm"
                type="date"
                value={antFecha}
                onChange={(e) => setAntFecha(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>Importe</Label>
              <Input
                bsSize="sm"
                type="number"
                min="0"
                step="any"
                placeholder="0.00"
                value={antImporte}
                onChange={(e) => setAntImporte(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Banco</Label>
              <Input
                bsSize="sm"
                type="select"
                value={antBanco}
                onChange={(e) => setAntBanco(e.target.value)}
              >
                <option value="">Selecciona</option>
                {/* En Bancos el nombre vive en `banco` y la cuenta en
                    `cuenta`; no hay campo `name`. */}
                {(bancos || [])
                  .sort((a, b) => (String(a.banco) > String(b.banco) ? 1 : -1))
                  .map((b) => (
                    <option key={b._id} value={b._id}>
                      {b.banco} {b.cuenta} {b.moneda ? `(${b.moneda})` : ""}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={6}>
              <Label>Forma de pago</Label>
              <Input
                bsSize="sm"
                type="select"
                value={antFormaPago}
                onChange={(e) => setAntFormaPago(e.target.value)}
              >
                <option value="Transferencia">Transferencia</option>
                <option value="Efectivo">Efectivo</option>
                <option value="Cheque">Cheque</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={6}>
              <Label>Tipo de cambio</Label>
              <Input
                bsSize="sm"
                type="number"
                min="0"
                step="any"
                value={antTipoCambio}
                onChange={(e) => setAntTipoCambio(e.target.value)}
              />
            </Col>
            <Col md={6}>
              <Label>Observaciones</Label>
              <Input
                bsSize="sm"
                type="text"
                value={antObservaciones}
                onChange={(e) => setAntObservaciones(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <p style={{ fontSize: 12, color: "#666" }}>
            Además del anticipo se registra el egreso en el banco elegido.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            color="success"
            onClick={guardarAnticipoNuevo}
            disabled={antGuardando}
          >
            {antGuardando ? "Guardando…" : "Guardar anticipo"}
          </Button>
          <Button size="sm" color="secondary" onClick={() => setModalAnticipoNuevo(false)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalAplicar} toggle={() => setModalAplicar(!modalAplicar)}>
        <ModalHeader toggle={() => setModalAplicar(!modalAplicar)}>
          <h4>
            Aplicar anticipo a {notaSel?.movimiento} — {nombreProveedor}
          </h4>
        </ModalHeader>
        <ModalBody>
          {anticiposProv.length === 0 ? (
            <div style={{ padding: 12, backgroundColor: "#fff3cd", borderRadius: 4 }}>
              Este proveedor no tiene anticipos con saldo disponible.
            </div>
          ) : (
            <>
              <Row>
                <Col md={4}>
                  <Label>Saldo de la nota</Label>
                  <Input
                    disabled
                    value={new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(notaSel?.saldo) || 0)}
                  />
                </Col>
                <Col md={5}>
                  <Label>Anticipo</Label>
                  <Input
                    type="select"
                    value={anticipoSel}
                    onChange={(e) => {
                      const id = e.target.value;
                      setAnticipoSel(id);
                      const ant = anticiposProv.find((x) => x._id === id);
                      // Default: lo menor entre el saldo del anticipo y el de la nota
                      const sugerido = Math.min(
                        Number(ant?.saldo || 0),
                        Number(notaSel?.saldo || 0)
                      );
                      setAplicarImporte(Number(sugerido.toFixed(2)));
                    }}
                  >
                    <option value="">Selecciona</option>
                    {anticiposProv.map((a) => (
                      <option key={a._id} value={a._id}>
                        #{a.idAnticipo} · {a.fecha} · disponible{" "}
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.saldo)}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label>Importe a aplicar</Label>
                  <Input
                    type="number"
                    min="0"
                    step="any"
                    value={aplicarImporte}
                    onChange={(e) => setAplicarImporte(e.target.value)}
                  />
                </Col>
              </Row>
              <br />
              <small style={{ color: "#6c757d" }}>
                Al aplicar un anticipo no se mueve ningún banco: el dinero ya salió
                cuando se registró el anticipo. Solo baja el saldo del anticipo y el
                de la nota.
              </small>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            onClick={guardarAplicarAnticipo}
            disabled={guardandoCXP || anticiposProv.length === 0}
          >
            {guardandoCXP ? "Aplicando..." : "Aplicar"}
          </Button>
          <Button color="secondary" onClick={() => setModalAplicar(false)} disabled={guardandoCXP}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default EstadoCuentaCXP;
